import React from "react";
import styled from "styled-components";

export default function RoundAndRepsInput(props) {
  const {
    index,
    value,
    setValue,
    placeholder,
    unit,
    isEdit,
  } = props;

  function handleChange(e) {
    setValue(e.target.value, index);
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <InputView>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
      <Text fontFamily='Poppins-Medium' fontSize={14} color='#4F4F4F' cursor='default'>{unit}</Text>
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 7px 15px;

  width: calc(100% - 32px);

  border: 1px solid #CBCBCB;
  border-radius: 14px;
  background-color: #F6F6F6;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 17px;

	width: 65%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #4F4F4F;

  border: none;
  background-color: #F6F6F6;

	::placeholder {
		color: #DBDBDB;
	}
  
  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
